import { broadcastResponseToMainFrame } from '@azure/msal-browser/redirect-bridge';

import { hasAuthResponseInUrl } from 'utils/Fetch/hasAuthResponseInUrl';

// msal-browser v5 no longer reads auth responses off the URL of the popup or hidden iframe it
// opened; the page the identity provider redirects back to has to relay them over a
// BroadcastChannel. The redirect URI is the app root, so this entry doubles as that relay. The
// bridge classifies the interaction from MSAL's state metadata itself: popup and iframe
// responses are broadcast to the main frame, top-level redirect returns are cached and
// navigated back to the origin URL for the booted app's handleRedirectPromise to pick up.
if (hasAuthResponseInUrl(window.location)) {
  broadcastResponseToMainFrame().catch(error => {
    console.error('MSAL redirect bridge failed:', error);
    // The URL only looked like an auth response (the bridge rejects non-MSAL state and has
    // already scrubbed the auth params from the URL), so boot the app instead of going blank.
    return import('./bootstrap');
  });
} else {
  import('./bootstrap');
}
